import { useInternalGraphql } from '../useInternalGraphql'

export function useValidateContentPathIds() {
  const { sendRequest } = useInternalGraphql({
    query: 'PathContentQueryDocument',
    runOnInit: false,
  })

  return async ({
    contentId,
    pathId,
    projectId,
  }: {
    contentId: string
    pathId: string
    projectId?: string
  }) => {
    const { data } =
      (await sendRequest({
        variables: { contentId, pathId },
        authContext: { projectId },
      })) || {}

    const paths = data?.paths || []

    const isPublishedContent = data?.content?.publishState === 'PUBLISHED'

    // get last draft when trying to validate published content, to be able to redirect to the correct draft
    let lastDraft
    if (isPublishedContent) {
      const childPath = data?.paths?.[0]?.childPaths?.[0]
      if (childPath) {
        const { id, content } = childPath
        lastDraft = {
          pathId: id,
          contentId: content.id,
        }
      }
    }

    const isValid = Boolean(paths.length > 0)

    return { isValid, lastDraft }
  }
}
